import { acceptImages, dropzoneValidation } from 'components/dropzone/utils';
import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';
import {
  CreateAnnouncementData,
  DraftAnnouncementFormData,
  AnnouncementType,
} from 'containers/announcements/types';

export const getFormInputs = (
  announcement: CreateAnnouncementData,
): TypedFormInputs<DraftAnnouncementFormData> => {
  const messageMaxLength =
    announcement.announcementType === AnnouncementType.Email ? 2000 : 1500;
  const subjectMaxLength =
    announcement.announcementType === AnnouncementType.Email ? 255 : 40;
  return {
    subject: {
      element: FormInputTypes.Field,
      elementProps: {
        label: 'Subject',
        maxLength: subjectMaxLength,
        showLengthCounterNote: true,
      },
      validation: { required: true },
      layout: GridColSpan.SpanFull,
    },
    message: {
      element: FormInputTypes.TextAreaField,
      elementProps: {
        label: 'Message',
        size: 'lg',
        maxLength: messageMaxLength,
        autosize: true,
        maxRows: 20,
        showLengthCounterNote: true,
      },
      validation: { required: true },
      layout: GridColSpan.SpanFull,
    },
    files: {
      element: FormInputTypes.Dropzone,
      label: 'Add attachments',
      elementProps: {
        isMulti: true,
        maxFiles: 5,
        uploadEntirePdf: true,
        accept: acceptImages,
      },
      validation: {
        validate: dropzoneValidation,
      },
      layout: GridColSpan.SpanFull,
    },
  };
};

export const getDefaultValues = (
  announcement: CreateAnnouncementData,
): DraftAnnouncementFormData => ({
  subject: announcement.subject ?? '',
  message: announcement.message ?? '',
  files: announcement.files ?? [],
});
